module.exports = __webpack_public_path__ + "img/borrow-bg.82b0a7c6.png";